import {
  AGREEMENT_TYPE,
  IAgreementTemplateResponse,
} from 'services/templates/agreement-template/types';
import {
  IContractTemplateForm,
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';

export const agreementTemplateQueryToFormItem = (
  agreement: IAgreementTemplateResponse,
  lowestAvailableId?: string
): IContractTemplateTreeItemForm | undefined => {
  const { id, position, ...formAgreement } = agreement;

  if (formAgreement.type === AGREEMENT_TYPE.text) {
    return {
      type: TEMPLATE_TYPE.agreement,
      content: {
        type: AGREEMENT_TYPE.text,
        selectAgreementTemplate: {
          ...formAgreement,
          options: [formAgreement.defaultValue],
        },
        textAgreementTemplate: formAgreement,
      },
      id: lowestAvailableId ?? id,
      children: [],
    };
  }

  if (formAgreement.type === AGREEMENT_TYPE.select) {
    const { options, ...textAgreementTemplate } = formAgreement;

    return {
      type: TEMPLATE_TYPE.agreement,
      content: {
        type: AGREEMENT_TYPE.select,
        selectAgreementTemplate: formAgreement,
        textAgreementTemplate: textAgreementTemplate,
      },
      id: lowestAvailableId ?? id,
      children: [],
    };
  }

  return undefined;
};

export const agreementTemplateQueryToForm = (
  agreement: IAgreementTemplateResponse
): IContractTemplateForm => {
  return contractTemplateUtil.agreement.initialValues(
    agreementTemplateQueryToFormItem(agreement, '2')
  );
};
